export default __webpack_public_path__ + "static/media/ESRB_EC_3.307adb75.png";